import { Box, Button, Stack } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import AddIcon from "@mui/icons-material/Add";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { maintenanceAnalysisColumnData } from "../../common/constants/gridRowColumn";
import {
  useCompany,
  useDealer,
  useFleetList,
  useMaintainance,
  useMovableColumn,
  useNewVehicle,
  usePagination,
  useReplacement,
  useSortableColumn,
  useUser,
} from "../../common/hooks";
import { SearchBar } from "../../components/SearchBar";
import { layoutStyle } from "../layout-ui/style";
import { DeleteDialog } from "../../components/DeleteDialog";
import { TruckLoader } from "./truckLoader";
import { useDebounce } from "../../components/useDebounce";
import {
  actionColumnFunction,
  checkFieldColumn,
  checkbox,
  ensureHeaderTooltip,
  getDefaultColDef,
  sidebarMenu,
} from "../../common/constants/commonFunction";
import { getCompanyId } from "../../common/constants/commonFunction";
import { TAB_CONTENT, TAB_VALUE } from "../../common/constants/popupMessage";
import { localStorageItemNames } from "../../common/constants";
import { PageNameConstant } from "../../common/constants/PageNameConstant";
import { PopupBlock } from "../../components/PopupBlock";
import {
  applyActiveSortToColumns,
  getActiveSortRequest,
  getActiveSortRecord,
  onSortChanged,
  sortRowsByActiveSort,
  updateGridSortState,
} from "../../common/utils/sortingColumn";
import { columnSortingMessage } from "../../common/utils/columnSortingMessage";
import { SortingTextPopup } from "../../components/SortingTextPopup";
import { DEALEAR_DEFAULT } from "../../common/constants/dealer-name";

export const MaintenanceAnalysis = () => {
  const classes = layoutStyle();
  const [columnFinal, setColumnFinal] = useState([]);
  const [rowDataFinal, setRowDataFinal] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  // const [deleteValue, setDeleteValue] = useState();
  // const { state } = useLocation();
  const navigation = useNavigate();
  const {
    getMaintananceApi,
    maintanance,
    deleteMaintananceByIdApi,
    loading,
    setMaintanance,
  } = useMaintainance();
  const { deletFleetListByIdApi } = useFleetList();
  const {
    setSelectedNav,
    columnChange,
    setColumnChange,
    popupBlock,
    setPopupBlock,
    setSidebarColumnPopup,
  } = useUser();
  const { companyNameHeader, dealerNameHeader } = useCompany();
  const userType = localStorage.getItem("type");
  const localUserId = localStorage.getItem(localStorageItemNames.userID);
  const defaultColDef = useMemo(
    () => ({ ...getDefaultColDef(), sortable: true }),
    []
  );
  const { setNewFleetNo } = useDealer();
  const { setToastClose, setNewVehicle } = useNewVehicle();
  const { setReplacementList } = useReplacement();
  const [localSortedColumn, setLocalSortedColumn] = useState([]);
  const gridRef = useRef(null);
  const [movableColumnData, setMovableColumnData] = useState([]);
  const {
    movableColumn,
    getMovableColumnApi,
    createMovableColumn,
    updateViewMovableColumn,
  } = useMovableColumn();
  // Use local state for sortedColumn to prevent cross-page contamination via shared context
  const sortedColumn = localSortedColumn;
  const setSortedColumn = setLocalSortedColumn;
  const [nextButton, setNextButton] = useState("");
  const [prevButton, setPrevButton] = useState("");
  const [openSortingPopup, setOpenSortingPopup] = useState(false);

  const {
    getSortableColumnApi,
    sortableColumnData,
    createSortableColumn,
    updateViewSortableColumn,
  } = useSortableColumn();
  const {
    setPagination,
    setFleetPagination,
    setMaintainancePagination,
    setFuelPagination,
    setFundingPagination,
  } = usePagination();

  useEffect(() => {
    getSortableColumnApi({
      filter: {
        userId: localUserId,
        pageName: PageNameConstant.maintenanceAnalysis,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      },
    });
    getMovableColumnApi({
      filter: {
        userId: localUserId,
        pageName: PageNameConstant.maintenanceAnalysis,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      },
    });
    setNewFleetNo(null);
    setToastClose(false);
    setNewVehicle([]);
    setReplacementList([]);
    setSidebarColumnPopup("");
    setPagination(0);
    setFleetPagination(0);
    setMaintainancePagination(0);
    setFuelPagination(0);
    setFundingPagination(0);
  }, []);
  const handleAddButton = () => {
    navigation("/new-fleetlist", {
      state: {
        tabValue: TAB_VALUE.FLEET_LIST,
        selectedContent: TAB_CONTENT.FLEET_LIST,
      },
    });
  };
  const onCellClicked = (event) => {
    let checkField = checkFieldColumn(event);
    if (checkField) {
      handleEditButton(event?.data);
    }
  };
  const handleEditButton = (params) => {
    navigation("/new-fleetlist", {
      state: {
        tabValue: TAB_VALUE.MAINTENANCE_ANALYSIS,
        selectedContent: TAB_CONTENT.MAINTENANCE_ANALYSIS,
        data: params,
      },
    });
  };

  const [deleteValue, setDeleteValue] = useState(null);

  const handleDeleteButton = async (values) => {
    setDeleteOpen(true);
    setDeleteValue({
      id: values?.maintenanceId ?? values?.id ?? values,
      fleetId: values?.fleetId,
      companyId: getCompanyId(userType, companyNameHeader),
      dealerId: DEALEAR_DEFAULT.dealerId,
      userId: localUserId,
    });
  };

  const handleDelete = async () => {
    if (!deleteValue) {
      setDeleteOpen(false);
      return;
    }

    const companyId = deleteValue?.companyId ?? getCompanyId(userType, companyNameHeader);
    const dealerId = deleteValue?.dealerId ?? DEALEAR_DEFAULT.dealerId;
    const userId = deleteValue?.userId ?? localUserId;
    await deleteMaintananceByIdApi({
      id: deleteValue?.id,
      companyId,
      dealerId,
      userId,
    });

    if (deleteValue?.fleetId) {
      await deletFleetListByIdApi({
        id: deleteValue.fleetId,
        companyId,
        dealerId,
        userId,
      });
    }
    setDeleteOpen(false);
    setDeleteValue(null);
  };

  // const [anchorElSearch, setAnchorElSearch] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  const onSearch = (e) => {
    debouncedSearch(e?.target?.value);
    handleClickSearch(e);
  };
  const handleClickSearch = (event) => {
    // setAnchorElSearch(event.currentTarget);
  };

  const onSearchFunc = (e) => {
    setSearchValue(e[0]);
  };
  const debouncedSearch = useDebounce(onSearchFunc, 500);

  useEffect(() => {
    const filteredRows = searchValue
      ? maintanance.filter((row) =>
          row?.fleetNo?.toLowerCase().includes(searchValue.toLowerCase())
        )
      : maintanance;
    setRowDataFinal(
      sortRowsByActiveSort(
        filteredRows,
        getActiveSortRecord(sortableColumnData)
      )
    );
  }, [maintanance, searchValue, sortableColumnData]);
  useEffect(() => {
    setColumnChange(false);

    const loadMaintenanceList = async () => {
      const sortResponse = await getSortableColumnApi({
        filter: {
          userId: localStorage.getItem(localStorageItemNames.userID),
          pageName: PageNameConstant.maintenanceAnalysis,
          companyId: localStorage.getItem(localStorageItemNames.companyId),
          dealerId: DEALEAR_DEFAULT.dealerId,
        },
      });
      if (companyNameHeader) {
        const companyId = getCompanyId(userType, companyNameHeader);
        getMaintananceApi({
          companyId: companyId,
          dealerId: DEALEAR_DEFAULT.dealerId,
          userId: localUserId,
          ...getActiveSortRequest(sortResponse),
        });
      } else {
        setMaintanance([]);
      }
    };
    getMovableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.maintenanceAnalysis,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      },
    });
    loadMaintenanceList();
  }, [companyNameHeader]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (movableColumnData) {
      const actionColumn = actionColumnFunction({
        selectedRows: selectedRows,
        handleEditButton: handleEditButton,
        handleDeleteButton: handleDeleteButton,
        deleteButton: true,
      });
      setColumnFinal([...movableColumnData]);
    }
  }, [movableColumnData]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const activeSort = getActiveSortRecord(sortableColumnData);
    if (activeSort && movableColumn?.length > 0) {
      let dataMovable = movableColumn[0];
      let columnParse = applyActiveSortToColumns(
        JSON.parse(dataMovable?.columnName),
        activeSort
      );
      setMovableColumnData(columnParse);
    } else if (movableColumn?.length > 0) {
      let dataMovable = movableColumn[0];
      let columnParse = JSON.parse(dataMovable?.columnName);
      setMovableColumnData(
        applyActiveSortToColumns(columnParse, activeSort)
      );
    } else {
      const actionColumn = actionColumnFunction({
        selectedRows: selectedRows,
        handleEditButton: handleEditButton,
        handleDeleteButton: handleDeleteButton,
        deleteButton: true,
      });
      setMovableColumnData([
        checkbox,
        ...applyActiveSortToColumns(maintenanceAnalysisColumnData, activeSort),
        actionColumn,
      ]);
    }
  }, [maintenanceAnalysisColumnData, movableColumn, sortableColumnData]);
  const handleNext = (event) => {
    if (columnChange) {
      setPopupBlock(true);
      setNextButton("/fuel-economy-comparison");
    } else {
      setSelectedNav(sidebarMenu.fuel);
      navigation("/fuel-economy-comparison");
    }
  };
  const handleBack = () => {
    if (columnChange) {
      setPopupBlock(true);
      setPrevButton("/strategic-replacement-plan");
    } else {
      setSelectedNav(sidebarMenu.replacement);
      navigation("/strategic-replacement-plan");
    }
  };
  const handleMovableColumn = async () => {
    const cols = gridRef.current?.api?.getAllGridColumns();
    const colNamesIndex = cols?.map((items, index) => items?.colDef);
    setMovableColumnData(colNamesIndex);
    if (movableColumn?.length > 0) {
      await updateViewMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.maintenanceAnalysis,
        ColumnName: JSON.stringify(colNamesIndex),
        id: movableColumn[0]?.id,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      });
    } else {
      await createMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.maintenanceAnalysis,
        ColumnName: JSON.stringify(colNamesIndex),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      });
    }
    setColumnChange(false);
  };
  const handleColumnChange = (event) => {
    if (event?.column) {
      const cols = gridRef.current?.api?.getAllGridColumns();
      const colNamesIndex = cols?.map((items, index) => items?.colDef);
      setMovableColumnData(colNamesIndex);
      setColumnChange(true);
    }
  };
  const onSortedColumnChange = () =>
    updateGridSortState(gridRef, setSortedColumn, setColumnFinal);
  const onSortedColumnChangeAlready = async () => {
    if (sortableColumnData?.length) {
      setOpenSortingPopup(true);
      return;
    }
    await onSortChanged(
      gridRef,
      setSortedColumn,
      setColumnFinal,
      sortableColumnData,
      createSortableColumn,
      updateViewSortableColumn,
      PageNameConstant.maintenanceAnalysis
    );
  };
  return (
    <Box className={classes.mainContent}>
      <Box className={classes.gridContantFleetList}>
        <Stack
          direction="row"
          sx={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <Box className={classes.headerNameText}>Maintenance & Repair Cost Comparison</Box>
          <Box className={classes.sortingFieldText}>
            {columnSortingMessage(sortableColumnData)}
          </Box>
        </Stack>
        <Stack
          direction="row"
          sx={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <Box></Box>
          <Box className={classes.addEditGrid}>
            {getActiveSortRecord(sortableColumnData) ? (
              <Button
                variant="contained"
                className={classes.replacementButtonAction}
                onClick={onSortedColumnChangeAlready}
                startIcon={<SortIcon style={{ fontSize: 15 }} />}
              >
                <span style={{ fontSize: 12 }}>Save Sort</span>
              </Button>
            ) : (
              <Button
                variant="contained"
                className={classes.replacementButtonAction}
                onClick={onSortedColumnChangeAlready}
                startIcon={<SortIcon style={{ fontSize: 15 }} />}
              >
                <span style={{ fontSize: 12 }}>Save Sort</span>
              </Button>
            )}
            <Button
              variant="contained"
              className={classes.replacementButtonAction}
              onClick={handleMovableColumn}
              startIcon={<ViewWeekIcon style={{ fontSize: 15 }} />}
            >
              <span style={{ fontSize: 12 }}>Save Columns</span>
            </Button>
            <Button
              variant="outlined"
              className={classes.replacementButtonSecondary}
              onClick={handleBack}
              startIcon={<ArrowBackIcon style={{ fontSize: 15 }} />}
            >
              <span style={{ fontSize: 12 }}>Back</span>
            </Button>
            <Button
              variant="contained"
              className={classes.replacementButtonPrimary}
              onClick={handleNext}
              endIcon={<ArrowForwardIcon style={{ fontSize: 15 }} />}
            >
              <span style={{ fontSize: 12 }}>Next</span>
            </Button>
            <Button
              variant="contained"
              className={classes.replacementButtonSuccess}
              onClick={handleAddButton}
              startIcon={<AddIcon style={{ fontSize: 15 }} />}
            >
              NEW
            </Button>
            <SearchBar onSearch={onSearch} />
          </Box>
        </Stack>
        {loading ? (
          <TruckLoader />
        ) : (
          <AgGridReact
            ref={gridRef}
            className="ag-theme-quartz"
            rowSelection="multiple"
            onSelectionChanged={(event) => {
              const selectedNodes = event.api.getSelectedNodes();
              const selectedRows = selectedNodes.map((node) => node.data);
              setSelectedRows(selectedRows);
            }}
            suppressRowClickSelection
            pagination={true}
            rowData={rowDataFinal}
            defaultColDef={defaultColDef}
            checkboxSelection
            columnDefs={ensureHeaderTooltip(columnFinal)}
            onCellClicked={onCellClicked}
            onColumnMoved={handleColumnChange}
            onSortChanged={onSortedColumnChange}
          />
        )}
      </Box>
      {deleteOpen && (
        <DeleteDialog
          open={deleteOpen}
          setOpen={() => setDeleteOpen(false)}
          deleteApi={() => handleDelete()}
        />
      )}
      {popupBlock && (
        <PopupBlock
          open={popupBlock}
          setOpen={() => setPopupBlock(false)}
          navigationRouteNext={nextButton}
          navigationRoutePrev={prevButton}
          selectedNavStyle={
            nextButton ? sidebarMenu.fuel : sidebarMenu.replacement
          }
          columnChangeData={movableColumnData}
          pageName={PageNameConstant.maintenanceAnalysis}
        />
      )}
      {openSortingPopup && (
        <SortingTextPopup
          open={openSortingPopup}
          setOpen={setOpenSortingPopup}
          gridRef={gridRef}
          setSortedColumn={setSortedColumn}
          setColumnFinal={setColumnFinal}
          columnFinal={columnFinal}
          sortableColumnData={sortableColumnData}
          createSortableColumn={createSortableColumn}
          updateViewSortableColumn={updateViewSortableColumn}
          pageName={PageNameConstant.maintenanceAnalysis}
        />
      )}
    </Box>
  );
};
